const BUNDLE_DRAWER_HASH = 'charm-builder';

class BundleDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#BundleDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.setBundleButtonAccessibility();
        this.setupBundleTypeClicks();
        this.setupBuyNowButton();
        this.initializeBundleTypeButtonTexts();
        this.setupHashNavigation();
      });
    } else {
      this.setBundleButtonAccessibility();
      this.setupBundleTypeClicks();
      this.setupBuyNowButton();
      this.initializeBundleTypeButtonTexts();
      this.setupHashNavigation();
    }
  }

  setHashInUrl() {
    if (window.location.hash !== '#' + BUNDLE_DRAWER_HASH) {
      const url = window.location.pathname + window.location.search + '#' + BUNDLE_DRAWER_HASH;
      window.history.replaceState(null, '', url);
    }
  }

  removeHashFromUrl() {
    if (window.location.hash === '#' + BUNDLE_DRAWER_HASH) {
      const url = window.location.pathname + window.location.search;
      window.history.replaceState(null, '', url);
    }
  }

  setupHashNavigation() {
    const openIfHash = () => {
      if (window.location.hash === '#' + BUNDLE_DRAWER_HASH && !this.classList.contains('active')) {
        const bundleButton = document.querySelector('.bundle-product-button');
        this.open(bundleButton || undefined);
      }
    };
    const closeIfHashRemoved = () => {
      if (window.location.hash !== '#' + BUNDLE_DRAWER_HASH && this.classList.contains('active')) {
        this.close();
      }
    };
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#' + BUNDLE_DRAWER_HASH) {
        openIfHash();
      } else {
        closeIfHashRemoved();
      }
    });
    openIfHash();
  }
  
  setupBundleTypeClicks() {
    const bundleTypeItems = this.querySelectorAll('.bundle-type-item');
    bundleTypeItems.forEach(item => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const blockId = item.dataset.blockId;
        const bundleType = item.dataset.bundleType;
        if (blockId && bundleType) {
          this.openProductDrawer(blockId, bundleType);
        }
      });
    });
  }
  
  openProductDrawer(blockId, bundleType, itemToReplace = null) {
    const productDrawer = this.querySelector('#BundleProductDrawer');
    const productDrawerContent = this.querySelector('#BundleProductDrawerContent');
    const leftBlock = this.querySelector('.drawer__left-block');
    
    if (!productDrawer || !productDrawerContent) return;
    
    this.currentBundleType = bundleType;
    this.itemToReplace = itemToReplace; 
    
    if (leftBlock) {
      leftBlock.style.display = 'none';
    }
    
    const drawerContents = this.querySelector('.drawer__contents.js-contents');
    const drawerFooter = this.querySelector('.drawer__footer');
    if (drawerContents) {
      drawerContents.style.display = 'none';
    }
    if (drawerFooter) {
      drawerFooter.style.display = 'none';
    }
    
    setTimeout(() => {
      productDrawer.classList.add('active');
    }, 50);
    
    const allProductContainers = productDrawerContent.querySelectorAll('.bundle-product-grid-container');
    let activeContainer = null;
    allProductContainers.forEach(container => {
      if (container.dataset.blockId === blockId) {
        container.style.display = 'block';
        activeContainer = container;
      } else {
        container.style.display = 'none';
      }
    });
    
    if (activeContainer) {
      const enableMultipleItems = activeContainer.dataset.enableMultipleItems === 'true';
      
      const closeBtn = activeContainer.querySelector('.bundle-product-slider__close-button') || 
                      activeContainer.querySelector('.bundle-product-multiple-grid__close-button');
      if (closeBtn) {
        closeBtn.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeProductDrawer();
        };
      }
      
      if (enableMultipleItems) {
        this.setupMultipleItemsGrid(activeContainer);
        this.initializeMultipleGridHeader(activeContainer);
        this.updateMultipleItemsGridButtonStates(activeContainer, bundleType);
        this.setupInfiniteScroll(activeContainer);
      } else {
        this.setupButtonStateForContainer(activeContainer);
        
        const sliderComponent = activeContainer.querySelector('slider-component');
        if (sliderComponent) {
          sliderComponent.addEventListener('slideChanged', () => {
            this.updateButtonStateForContainer(activeContainer);
          });
        }
      }
    }
  }
  
  setupProductGridClicks(container) {
  }
  
  setupMultipleItemsGrid(container) {
    const bundleType = container.dataset.bundleType;
    const gridItems = container.querySelectorAll('.bundle-product-multiple-item');
    
    gridItems.forEach(item => {
      const addButton = item.querySelector('.bundle-product-multiple-item__add-button');
      if (addButton) {
        const newButton = addButton.cloneNode(true);
        addButton.parentNode.replaceChild(newButton, addButton);
        
        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const variantAvailable = item.dataset.variantAvailable;
          if (variantAvailable === 'false') {
            return;
          }
          
          const productId = newButton.dataset.productId;
          const variantId = newButton.dataset.variantId;
          const variantPrice = newButton.dataset.variantPrice;
          const productTitle = newButton.dataset.productTitle;
          const bundleType = newButton.dataset.bundleType;
          const productHandle = newButton.dataset.productHandle;
          
          if (productId && variantId && bundleType) {
            const bundleTypeContainer = this.querySelector(`.bundle-type-selected-products[data-bundle-type="${bundleType}"]`);
            const existingItem = bundleTypeContainer ? bundleTypeContainer.querySelector(`[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`) : null;
            
            if (existingItem) {
              this.removeProductFromBundle(productId, bundleType);
            } else {
              const productImageSrc = item.dataset.productImage || '';
              this.addProductToBundle(productId, variantId, variantPrice, productTitle, bundleType, productHandle, productImageSrc);
            }
          }
        });
      }
      
      item.addEventListener('click', (e) => {
        if (e.target.closest('.bundle-product-multiple-item__add-button')) {
          return;
        }
        
        const addButton = item.querySelector('.bundle-product-multiple-item__add-button');
        if (addButton) {
          addButton.click();
        }
      });
      
      item.addEventListener('mouseenter', () => {
        this.updateMultipleGridHeader(container, item);
      });
      
      item.addEventListener('mouseleave', () => {
        this.clearMultipleGridHeader(container);
      });
    });
    
    this.updateMultipleItemsGridButtonStates(container, bundleType);
  }
  
  updateMultipleItemsGridButtonStates(container, bundleType) {
    const bundleTypeContainer = this.querySelector(`.bundle-type-selected-products[data-bundle-type="${bundleType}"]`);
    if (!bundleTypeContainer) return;
    
    const bundleTypeButton = this.querySelector(`.bundle-type-item[data-bundle-type="${bundleType}"]`);
    const maxItems = bundleTypeButton ? parseInt(bundleTypeButton.dataset.maxItems) || 4 : 4;
    const currentItems = bundleTypeContainer.querySelectorAll('.bundle-type-selected-item');
    const currentItemsCount = currentItems.length;
    const isMaxReached = currentItemsCount >= maxItems;
    
    const gridItems = container.querySelectorAll('.bundle-product-multiple-item');
    gridItems.forEach(item => {
      const productId = item.dataset.productId;
      const addButton = item.querySelector('.bundle-product-multiple-item__add-button');
      
      if (addButton && productId) {
        const variantAvailable = item.dataset.variantAvailable;
        
        if (variantAvailable === 'false') {
          addButton.disabled = true;
          addButton.classList.add('bundle-product-multiple-item__add-button--sold-out');
          item.classList.add('bundle-product-multiple-item--sold-out');
          return;
        }
        
        const existingItem = bundleTypeContainer.querySelector(`[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
        
        if (existingItem) {
          addButton.disabled = false;
          addButton.classList.add('bundle-product-multiple-item__add-button--added');
          item.classList.add('bundle-product-multiple-item--added');
          addButton.classList.remove('bundle-product-multiple-item__add-button--max-reached');
        } else {
          if (isMaxReached) {
            addButton.disabled = true;
            addButton.classList.add('bundle-product-multiple-item__add-button--max-reached');
          } else {
            addButton.disabled = false;
            addButton.classList.remove('bundle-product-multiple-item__add-button--max-reached');
          }
          addButton.classList.remove('bundle-product-multiple-item__add-button--added');
          item.classList.remove('bundle-product-multiple-item--added');
        }
      }
    });
  }
  
  updateMultipleGridHeader(container, item) {
    const header = container.querySelector('.bundle-product-multiple-grid__header');
    if (!header) return;
    
    const productTitle = item.dataset.productTitle;
    const variantPrice = item.dataset.variantPrice;
    
    const titleElement = header.querySelector('.bundle-product-multiple-grid__title');
    const priceElement = header.querySelector('.bundle-product-multiple-grid__price');
    const defaultText = header.querySelector('.bundle-product-multiple-grid__default-text');
    
    if (defaultText) {
      defaultText.style.display = 'none';
    }
    
    if (titleElement && productTitle) {
      const existingDefault = titleElement.querySelector('.bundle-product-multiple-grid__default-text');
      if (existingDefault) {
        existingDefault.remove();
      }
      titleElement.textContent = productTitle;
    }
    
    if (priceElement && variantPrice) {
      priceElement.textContent = this.formatMoney(parseInt(variantPrice));
    }
  }
  
  initializeMultipleGridHeader(container) {
    const header = container.querySelector('.bundle-product-multiple-grid__header');
    if (!header) return;
    
    const titleElement = header.querySelector('.bundle-product-multiple-grid__title');
    const priceElement = header.querySelector('.bundle-product-multiple-grid__price');
    
    const defaultText = titleElement.querySelector('.bundle-product-multiple-grid__default-text');
    if (defaultText) {
      defaultText.style.display = '';
    } else {
      titleElement.innerHTML = '<span class="bundle-product-multiple-grid__default-text"><span class="bundle-product-multiple-grid__default-title">Select Your Charms</span></span>';
    }
    
    if (priceElement) {
      priceElement.textContent = '';
    }
  }
  
  clearMultipleGridHeader(container) {
    const header = container.querySelector('.bundle-product-multiple-grid__header');
    if (!header) return;
    
    const titleElement = header.querySelector('.bundle-product-multiple-grid__title');
    const priceElement = header.querySelector('.bundle-product-multiple-grid__price');
    
    const defaultText = titleElement.querySelector('.bundle-product-multiple-grid__default-text');
    if (!defaultText) {
      titleElement.innerHTML = '<span class="bundle-product-multiple-grid__default-text"><span class="bundle-product-multiple-grid__default-title">Select Your Charms</span></span>';
    } else {
      defaultText.style.display = '';
    }
    
    if (priceElement) {
      priceElement.textContent = '';
    }
  }
  
  getVisibleSlide(container) {
    const slider = container.querySelector('.bundle-product-slider__container');
    if (!slider) return null;
    
    const activeSlide = slider.querySelector('.bundle-product-slider__slide.is-active');
    if (activeSlide) {
      return activeSlide;
    }
    
    const slides = slider.querySelectorAll('.bundle-product-slider__slide');
    return slides.length > 0 ? slides[0] : null;
  }
  
  setupButtonStateForContainer(container) {
    this.updateButtonStateForContainer(container);
  }
  
  updateButtonStateForContainer(container) {
    const addButton = container.querySelector('.bundle-product-slider__add-button');
    if (!addButton) return;
    
    const bundleType = container.dataset.bundleType;
    const enableMultipleItems = container.dataset.enableMultipleItems === 'true';
    
    if (enableMultipleItems) {
      addButton.textContent = 'ADD';
      addButton.classList.remove('bundle-product-slider__add-button--checked', 'bundle-product-slider__add-button--replace');
      addButton.disabled = false;
      return;
    }
    
    const visibleSlide = this.getVisibleSlide(container);
    if (!visibleSlide) {
      addButton.textContent = 'ADD';
      addButton.classList.remove('bundle-product-slider__add-button--checked', 'bundle-product-slider__add-button--replace');
      addButton.disabled = false;
      return;
    }
    
    const productGrid = visibleSlide.querySelector('.bundle-product-item-grid');
    if (!productGrid) {
      addButton.textContent = 'ADD';
      addButton.classList.remove('bundle-product-slider__add-button--checked', 'bundle-product-slider__add-button--replace');
      addButton.disabled = false;
      return;
    }
    
    const currentProductId = productGrid.dataset.productId;
    if (!currentProductId) {
      addButton.textContent = 'ADD';
      addButton.classList.remove('bundle-product-slider__add-button--checked', 'bundle-product-slider__add-button--replace');
      addButton.disabled = false;
      return;
    }
    
    const variantAvailable = productGrid.dataset.variantAvailable;
    if (variantAvailable === 'false') {
      addButton.textContent = 'SOLD OUT';
      addButton.classList.remove('bundle-product-slider__add-button--checked', 'bundle-product-slider__add-button--replace');
      addButton.disabled = true;
      return;
    }
    
    const bundleTypeContainer = this.querySelector(`.bundle-type-selected-products[data-bundle-type="${bundleType}"]`);
    const existingItem = bundleTypeContainer ? bundleTypeContainer.querySelector(`[data-product-id="${currentProductId}"][data-bundle-type="${bundleType}"]`) : null;
    
    const allSelectedItems = bundleTypeContainer ? bundleTypeContainer.querySelectorAll('.bundle-type-selected-item') : [];
    const hasOtherItems = allSelectedItems.length > 0 && !existingItem;
    
    if (existingItem) {
      addButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      addButton.classList.add('bundle-product-slider__add-button--checked');
      addButton.classList.remove('bundle-product-slider__add-button--replace');
      addButton.disabled = true;
    } else if (hasOtherItems) {
      addButton.textContent = 'REPLACE';
      addButton.classList.add('bundle-product-slider__add-button--replace');
      addButton.classList.remove('bundle-product-slider__add-button--checked');
      addButton.disabled = false;
    } else {
      addButton.textContent = 'ADD';
      addButton.classList.remove('bundle-product-slider__add-button--checked', 'bundle-product-slider__add-button--replace');
      addButton.disabled = false;
    }
  }
  
  setupAddButtons() {
    const addButtons = this.querySelectorAll('.bundle-product-slider__add-button');
    addButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (button.disabled) return;
        
        const blockId = button.dataset.blockId;
        const bundleType = button.dataset.bundleType;
        
        const sliderContainer = button.closest('.bundle-product-grid-container');
        if (!sliderContainer) return;
        
        const visibleSlide = this.getVisibleSlide(sliderContainer);
        
        if (visibleSlide) {
          const productGrid = visibleSlide.querySelector('.bundle-product-item-grid');
          if (productGrid) {
            const variantAvailable = productGrid.dataset.variantAvailable;
            if (variantAvailable === 'false') {
              return;
            }
            
            const productId = productGrid.dataset.productId;
            const variantId = productGrid.dataset.variantId;
            const variantPrice = productGrid.dataset.variantPrice;
            const productTitle = productGrid.dataset.productTitle;
            const productHandle = productGrid.dataset.productHandle;
            
            const productImage = productGrid.querySelector('.bundle-product-item-grid__image');
            const productImageSrc = productImage ? productImage.src : '';
            
            if (productId && variantId && bundleType) {
              this.addProductToBundle(productId, variantId, variantPrice, productTitle, bundleType, productHandle, productImageSrc);
            }
          }
        }
      });
    });
  }
  
  addProductToBundle(productId, variantId, variantPrice, productTitle, bundleType, productHandle, productImageSrc = null) {
    const bundleTypeContainer = this.querySelector(`.bundle-type-selected-products[data-bundle-type="${bundleType}"]`);
    if (!bundleTypeContainer) return;
    
    const isReplacing = !!this.itemToReplace;
    
    if (!isReplacing) {
      const bundleTypeButton = this.querySelector(`.bundle-type-item[data-bundle-type="${bundleType}"]`);
      const enableMultipleItems = bundleTypeButton && bundleTypeButton.dataset.enableMultipleItems === 'true';
      
      const existingItem = bundleTypeContainer.querySelector(`[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
      if (existingItem) {
        return;
      }
      
      if (enableMultipleItems) {
        const maxItems = bundleTypeButton ? parseInt(bundleTypeButton.dataset.maxItems) || 4 : 4;
        const currentItems = bundleTypeContainer.querySelectorAll('.bundle-type-selected-item');
        if (currentItems.length >= maxItems) {
          alert(`You can only add up to ${maxItems} items for ${bundleType}. Please remove an item first.`);
          return;
        }
      } else {
        const existingItems = bundleTypeContainer.querySelectorAll('.bundle-type-selected-item');
        if (existingItems.length > 0) {
          existingItems.forEach(item => item.remove());
        }
      }
    }
    
    const selectedList = this.querySelector('#BundleSelectedList');
    if (selectedList) {
      const existingItemFooter = selectedList.querySelector(`[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
      if (existingItemFooter) {
        return;
      }
    }
    
    let imageSrc = productImageSrc || '';
    
    if (!imageSrc) {
      const multipleItem = document.querySelector(`.bundle-product-multiple-item[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
      if (multipleItem) {
        const imageFromDataset = multipleItem.dataset.productImage;
        if (imageFromDataset) {
          imageSrc = imageFromDataset;
        } else {
          const imageElement = multipleItem.querySelector('.bundle-product-multiple-item__image');
          if (imageElement) {
            imageSrc = imageElement.src;
          }
        }
      }
    }
    
    if (!imageSrc) {
      const productItem = document.querySelector(`.bundle-product-item-grid[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
      if (productItem) {
        const productImage = productItem.querySelector('.bundle-product-item-grid__image');
        if (productImage) {
          imageSrc = productImage.src;
        }
      }
    }
    
    let productTags = '';
    const productItem = document.querySelector(`.bundle-product-item-grid[data-product-id="${productId}"]`) || 
                        document.querySelector(`.bundle-product-multiple-item[data-product-id="${productId}"]`);
    if (productItem && productItem.dataset.productTags) {
      productTags = productItem.dataset.productTags;
    }
    
    const itemHtml = `
      <div 
        class="bundle-type-selected-item" 
        data-product-id="${productId}"
        data-variant-id="${variantId}"
        data-variant-price="${variantPrice}"
        data-product-tags="${productTags}"
        data-bundle-type="${bundleType}"
      >
        <div class="bundle-type-selected-item__image-wrapper">
          <img class="bundle-type-selected-item__image" src="${imageSrc}" alt="${this.escapeHtml(productTitle)}" width="60" />
          <div class="bundle-type-selected-item__remove" data-product-id="${productId}" data-bundle-type="${bundleType}">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
        </div>
        <div class="bundle-type-selected-item__title">${this.escapeHtml(productTitle)}</div>
      </div>
    `;
    
    if (this.itemToReplace) {
      this.itemToReplace.remove();
      this.itemToReplace = null;
    }
    
    bundleTypeContainer.insertAdjacentHTML('beforeend', itemHtml);
    
    const newItem = bundleTypeContainer.querySelector(`[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
    if (newItem) {
      const removeBtn = newItem.querySelector('.bundle-type-selected-item__remove');
      if (removeBtn) {
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeProductFromBundle(productId, bundleType);
        });
      }
      
      newItem.addEventListener('click', (e) => {
        if (e.target.closest('.bundle-type-selected-item__remove')) {
          return;
        }
        
        const bundleTypeButton = this.querySelector(`.bundle-type-item[data-bundle-type="${bundleType}"]`);
        const blockId = bundleTypeButton ? bundleTypeButton.dataset.blockId : null;
        if (blockId) {
          this.openProductDrawer(blockId, bundleType, newItem);
        }
      });
    }
    
    this.updateBundleTotal();
    this.updateBundleTypeButtonText(bundleType);

    this.updateBundlePreview();
    
    const activeContainer = this.querySelector('.bundle-product-grid-container[style*="block"]');
    if (activeContainer && activeContainer.dataset.bundleType === bundleType) {
      const enableMultipleItems = activeContainer.dataset.enableMultipleItems === 'true';
      if (!enableMultipleItems) {
        this.updateButtonStateForContainer(activeContainer);
        this.closeProductDrawer();
      } else {
        this.updateMultipleItemsGridButtonStates(activeContainer, bundleType);
      }
    } else {
      this.closeProductDrawer();
    }
  }
  
  initializeBundleTypeButtonTexts() {
    const bundleTypeButtons = this.querySelectorAll('.bundle-type-item');
    bundleTypeButtons.forEach(button => {
      const bundleType = button.dataset.bundleType;
      if (bundleType) {
        this.updateBundleTypeButtonText(bundleType);
      }
    });
    
    this.setupSelectedItemClicks();
  }
  
  setupSelectedItemClicks() {
    const selectedItems = this.querySelectorAll('.bundle-type-selected-item');
    selectedItems.forEach(item => {
      const bundleType = item.dataset.bundleType;
      const bundleTypeButton = this.querySelector(`.bundle-type-item[data-bundle-type="${bundleType}"]`);
      const blockId = bundleTypeButton ? bundleTypeButton.dataset.blockId : null;
      
      if (blockId) {
        item.addEventListener('click', (e) => {
          if (e.target.closest('.bundle-type-selected-item__remove')) {
            return;
          }
          this.openProductDrawer(blockId, bundleType, item);
        });
      }
    });
  }
  
  updateBundleTypeButtonText(bundleType) {
    const bundleTypeContainer = this.querySelector(`.bundle-type-selected-products[data-bundle-type="${bundleType}"]`);
    const bundleTypeButton = this.querySelector(`.bundle-type-item[data-bundle-type="${bundleType}"]`);
    
    if (!bundleTypeContainer || !bundleTypeButton) return;
    
    const selectedItems = bundleTypeContainer.querySelectorAll('.bundle-type-selected-item');
    const buttonText = bundleTypeButton.querySelector('.bundle-type-item__text span');
    const iconContainer = bundleTypeButton.querySelector('.bundle-type-item__icon');
    
    if (buttonText) {
      const bundleTypeName = bundleTypeButton.dataset.bundleType;
      if (selectedItems.length > 0) {
        buttonText.textContent = `Edit ${bundleTypeName}`;
        if (iconContainer) {
          iconContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" class="icon" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2.00004C11.5084 1.82493 11.7163 1.68698 11.9441 1.59481C12.1719 1.50264 12.4151 1.45837 12.6667 1.45837C12.9182 1.45837 13.1614 1.50264 13.3892 1.59481C13.617 1.68698 13.8249 1.82493 14 2.00004C14.1751 2.17515 14.313 2.38305 14.4052 2.61087C14.4974 2.83869 14.5417 3.0819 14.5417 3.33337C14.5417 3.58485 14.4974 3.82806 14.4052 4.05588C14.313 4.2837 14.1751 4.4916 14 4.66671L5.00001 13.6667L1.33334 14.6667L2.33334 11L11.3333 2.00004Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        }
      } else {
        buttonText.textContent = `Add ${bundleTypeName}`;
        if (iconContainer) {
          iconContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" class="icon" viewBox="0 0 20 20"><path d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>`;
        }
      }
    }
  }
  
  clearAllSelectedItems() {
    const allSelectedContainers = this.querySelectorAll('.bundle-type-selected-products');
    allSelectedContainers.forEach(container => {
      const items = container.querySelectorAll('.bundle-type-selected-item');
      items.forEach(item => item.remove());
    });
    
    const allBundleTypeButtons = this.querySelectorAll('.bundle-type-item');
    allBundleTypeButtons.forEach(button => {
      const bundleType = button.dataset.bundleType;
      if (bundleType) {
        this.updateBundleTypeButtonText(bundleType);
      }
    });
    
    this.updateBundleTotal();
  }
  
  removeProductFromBundle(productId, bundleType) {
    const bundleTypeContainer = this.querySelector(`.bundle-type-selected-products[data-bundle-type="${bundleType}"]`);
    if (bundleTypeContainer) {
      const item = bundleTypeContainer.querySelector(`[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
      if (item) {
        item.remove();
      }

    }
    
    const selectedList = this.querySelector('#BundleSelectedList');
    if (selectedList) {
      const item = selectedList.querySelector(`[data-product-id="${productId}"][data-bundle-type="${bundleType}"]`);
      if (item) {
        item.remove();
      }
    }
    
    this.updateBundleTotal();
    this.updateBundleTypeButtonText(bundleType);
    this.updateBundlePreview();
    
    const activeContainer = this.querySelector('.bundle-product-grid-container[style*="block"]');
    if (activeContainer && activeContainer.dataset.bundleType === bundleType) {
      const enableMultipleItems = activeContainer.dataset.enableMultipleItems === 'true';
      if (!enableMultipleItems) {
        this.updateButtonStateForContainer(activeContainer);
      } else {
        this.updateMultipleItemsGridButtonStates(activeContainer, bundleType);
      }
    }
  }
  
  closeProductDrawer() {
    const productDrawer = this.querySelector('#BundleProductDrawer');
    const leftBlock = this.querySelector('.drawer__left-block');
    this.itemToReplace = null;
    
    if (productDrawer) {
      productDrawer.classList.remove('active');
      setTimeout(() => {
        if (leftBlock) {
          leftBlock.style.display = '';
        }
        
        const drawerContents = this.querySelector('.drawer__contents.js-contents');
        const drawerFooter = this.querySelector('.drawer__footer');
        if (drawerContents) {
          drawerContents.style.display = '';
        }
        if (drawerFooter) {
          drawerFooter.style.display = '';
        }
      }, 300);
    } else {
      if (leftBlock) {
        leftBlock.style.display = '';
      }
      
      const drawerContents = this.querySelector('.drawer__contents.js-contents');
      const drawerFooter = this.querySelector('.drawer__footer');
      if (drawerContents) {
        drawerContents.style.display = '';
      }
      if (drawerFooter) {
        drawerFooter.style.display = '';
      }
    }
  }
  
  setupBuyNowButton() {
    const buyNowButton = this.querySelector('#BundleDrawer-AddToCart');
    if (buyNowButton) {
      buyNowButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addBundleToCart();
      });
    }
  }
  
  async addBundleToCart() {
    const buyNowButton = this.querySelector('#BundleDrawer-AddToCart');
    if (!buyNowButton) return;
    
    const selectedItems = this.querySelectorAll('.bundle-type-selected-item');
    const selectedVariants = [];
    
    selectedItems.forEach(item => {
      const variantId = item.dataset.variantId;
      if (variantId) {
        selectedVariants.push({
          'id': variantId,
          'quantity': 1
        });
      }
    });
    
    if (selectedVariants.length === 0) {
      alert('Please select at least one product to add to cart.');
      return;
    }
    buyNowButton.setAttribute('aria-disabled', 'true');
    buyNowButton.disabled = true;
    buyNowButton.classList.add('loading');
    const originalText = buyNowButton.textContent;
    buyNowButton.textContent = 'Adding to cart...';
    
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      
      let lastResponse = null;
      
      for (const variant of selectedVariants) {
        const config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          }
        };
        
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        const formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', variant.quantity);
        
        if (cartDrawer && variant === selectedVariants[selectedVariants.length - 1]) {
          const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        
        config.body = formData;
        
        const response = await fetch(`${window.routes.cart_add_url}`, config);
        const result = await response.json();
        
        if (result.status) {
          throw new Error(result.description || 'Failed to add item to cart');
        }
        if (variant === selectedVariants[selectedVariants.length - 1]) {
          lastResponse = result;
        }
      }
      
      this.clearAllSelectedItems();
      
      if (cartDrawer) {
        this.close();
        
        if (lastResponse && lastResponse.sections) {
          cartDrawer.renderContents(lastResponse);
        } else {
          const sectionsToRender = cartDrawer.getSectionsToRender();
          const sectionNames = sectionsToRender.map((section) => section.id);
          const cartUrl = `${window.routes.cart_url}?sections=${sectionNames.join(',')}&sections_url=${encodeURIComponent(window.location.pathname)}`;
          
          const cartResponse = await fetch(cartUrl);
          const cartText = await cartResponse.text();
          const cartState = JSON.parse(cartText);
          
          cartDrawer.renderContents(cartState);
        }
        if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

      } else {
        this.close();
      }
      
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      alert(error.message || 'Failed to add items to cart. Please try again.');
    } finally {
      buyNowButton.removeAttribute('aria-disabled');
      buyNowButton.disabled = false;
      buyNowButton.classList.remove('loading');
      buyNowButton.textContent = originalText;
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  checkMandatoryItemsSelected() {
    const mandatoryButtons = this.querySelectorAll('.bundle-type-item[data-item-added-mandatory="true"]');
    
    if (mandatoryButtons.length === 0) {
      return true;
    }
    
    for (const button of mandatoryButtons) {
      const bundleType = button.dataset.bundleType;
      if (!bundleType) continue;
      
      const bundleTypeContainer = this.querySelector(`.bundle-type-selected-products[data-bundle-type="${bundleType}"]`);
      if (!bundleTypeContainer) return false;
      
      const selectedItems = bundleTypeContainer.querySelectorAll('.bundle-type-selected-item');
      if (selectedItems.length === 0) {
        return false;
      }
    }
    
    return true;
  }
  
  updateBundleTotal() {
    const selectedItems = this.querySelectorAll('.bundle-type-selected-item');
    let total = 0;
    
    selectedItems.forEach(item => {
      const variantPrice = item.dataset.variantPrice;
      if (variantPrice) {
        total += parseInt(variantPrice);
      }
    });
    
    const subtotalElement = this.querySelector('.totals__subtotal-value');
    if (subtotalElement) {
      subtotalElement.textContent = this.formatMoney(total);
    }
    
    const buyNowButton = this.querySelector('#BundleDrawer-AddToCart');
    if (buyNowButton) {
      const allMandatoryItemsSelected = this.checkMandatoryItemsSelected();
      
      if (allMandatoryItemsSelected && selectedItems.length > 0) {
        buyNowButton.removeAttribute('aria-disabled');
        buyNowButton.disabled = false;
        buyNowButton.textContent = 'Add to cart';
      } else {
        buyNowButton.setAttribute('aria-disabled', 'true');
        buyNowButton.disabled = true;
        buyNowButton.textContent = 'Build your own bag charm';
      }
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }
  
  updateBundlePreview() {
    const previewContainer = this.querySelector('#BundlePreviewContainer');
    if (!previewContainer) return;
    const introCircle = this.querySelector('#BundlePreviewIntroCircle');
    const imageWrapper = this.querySelector('#BundlePreviewImageWrapper');
    const allSelectedContainers = this.querySelectorAll('.bundle-type-selected-products');
    let claspContainer = null;
    let chamContainer = null;
    
    allSelectedContainers.forEach(container => {
      const bundleType = container.dataset.bundleType || '';
      const bundleTypeLower = bundleType.toLowerCase();
      if (bundleTypeLower.includes('clasp')) {
        claspContainer = container;
      } else if (bundleTypeLower.includes('charm')) {
        chamContainer = container;
      }
    });
    const claspItem = claspContainer ? claspContainer.querySelector('.bundle-type-selected-item') : null;
    const chamItems = chamContainer ? chamContainer.querySelectorAll('.bundle-type-selected-item') : [];
    const claspPreview = this.querySelector('#BundlePreviewClasp');
    const charmsPreview = this.querySelector('#BundlePreviewCharms');
    
    const hasSelection = claspItem || chamItems.length > 0;
    
    if (!hasSelection) {
      previewContainer.style.display = 'flex';
      if (introCircle) introCircle.style.display = 'flex';
      if (imageWrapper) imageWrapper.style.display = 'none';
      return;
    }
    
    previewContainer.style.display = 'flex';
    if (introCircle) introCircle.style.display = 'none';
    if (imageWrapper) imageWrapper.style.display = 'flex';
    
    let claspImageSrc = '';
    let claspTags = '';
    let isClaspWithChain = false;
    
    if (claspItem) {
      const claspImage = claspItem.querySelector('.bundle-type-selected-item__image');
      claspImageSrc = claspImage ? claspImage.src : '';
      claspTags = claspItem.dataset.productTags || '';
      isClaspWithChain = claspTags.toLowerCase().includes('clasp-with-chain');
      
      if (claspPreview && claspImageSrc) {
        claspPreview.innerHTML = `<img src="${claspImageSrc}" alt="Clasp" class="bundle-preview-clasp-image" />`;
      }
    } else if (claspPreview) {
      claspPreview.innerHTML = '';
    }
    if (charmsPreview) {
      charmsPreview.innerHTML = '';
      chamItems.forEach((item, index) => {
        const charmImage = item.querySelector('.bundle-type-selected-item__image');
        const charmImageSrc = charmImage ? charmImage.src : '';
        
        if (charmImageSrc) {
          const charmElement = document.createElement('div');
          charmElement.className = 'bundle-preview-charm';
          charmElement.style.backgroundImage = `url(${charmImageSrc})`;
          
          if (isClaspWithChain) {
            charmElement.classList.add('bundle-preview-charm--alternating');
            if (index % 2 === 0) {
              charmElement.classList.add('bundle-preview-charm--left');
              charmElement.style.setProperty('--charm-rotation', '45deg');
            } else {
              charmElement.classList.add('bundle-preview-charm--right');
              charmElement.style.setProperty('--charm-rotation', '315deg');
            }
            charmElement.style.setProperty('--charm-index', index);
          } else {            
            charmElement.classList.add(`${claspTags}-bundle-preview-charm--rotated`);
            charmElement.style.setProperty('--charm-index', index);
          }
          
          charmsPreview.appendChild(charmElement);
        }
      });
    }
  }


  setBundleButtonAccessibility() {
    const bundleButton = document.querySelector('.bundle-product-button');
    if (!bundleButton) {
      setTimeout(() => this.setBundleButtonAccessibility(), 100);
      return;
    }
    
    const bundleDrawer = document.querySelector('.bundle-drawer.drawer');
    bundleButton.setAttribute('role', 'button');
    bundleButton.setAttribute('aria-haspopup', 'dialog');
    bundleButton.addEventListener('click', (event) => {
      event.preventDefault();
      
      if(bundleDrawer && bundleDrawer.classList.contains('active')) {
        this.close(bundleButton)
      }
      else {
        this.open(bundleButton)
      }
    });
    bundleButton.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(bundleButton);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('BundleDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      
      const productDrawerContent = this.querySelector('#BundleProductDrawerContent');
      if (productDrawerContent) {
        const allContainers = productDrawerContent.querySelectorAll('.bundle-product-grid-container');
        allContainers.forEach(container => {
          this.setupProductGridClicks(container);
        });
        this.setupAddButtons();
      }
      
      this.updateBundleTotal();
      this.updateBundlePreview();
      const buyNowButton = this.querySelector('#BundleDrawer-AddToCart');
      if (buyNowButton) {
        const selectedItems = this.querySelectorAll('.bundle-type-selected-item');
        const allMandatoryItemsSelected = this.checkMandatoryItemsSelected();
        
        if (allMandatoryItemsSelected && selectedItems.length > 0) {
          buyNowButton.textContent = 'Add to cart';
        } else {
          buyNowButton.textContent = 'Build your own bag charm';
        }
      }
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    this.setHashInUrl();
  }

  close() {
    this.classList.remove('active', 'fullscreen');
    this.closeProductDrawer();
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.removeHashFromUrl();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setupInfiniteScroll(container) {
    const grid = container.querySelector('.bundle-product-multiple-grid');
    if (!grid) return;

    let observer;
    let isLoading = false;

    const observeSentinel = (sentinel) => {
      if (!sentinel) return;

      observer = new IntersectionObserver(async ([entry]) => {
        if (!entry.isIntersecting || isLoading) return;

        const nextUrl = sentinel.dataset.nextUrl;
        if (!nextUrl) return;

        isLoading = true;
        observer.disconnect();

        try {
          const url = new URL(nextUrl, window.location.origin);

          url.pathname = window.location.pathname;

          const res = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          const html = await res.text();

          const doc = new DOMParser().parseFromString(html, 'text/html');

          // Append new products
          doc
            .querySelectorAll('.bundle-product-multiple-item')
            .forEach((item) => {
              grid.appendChild(item);
            });

          // Re-bind buttons for newly added items
          this.setupMultipleItemsGrid(container);

          // Replace sentinel
          const newSentinel = doc.querySelector('.bundle-pagination-sentinel');
          if (newSentinel) {
            sentinel.replaceWith(newSentinel);
            observeSentinel(newSentinel);
          } else {
            sentinel.remove();
          }
        } catch (err) {
          console.error('Infinite scroll failed', err);
        } finally {
          isLoading = false;
        }
      }, {
        root: container,
        rootMargin: '200px'
      });

      observer.observe(sentinel);
    };

    const initialSentinel = container.querySelector('.bundle-pagination-sentinel');
    observeSentinel(initialSentinel);
  }
}

customElements.define('bundle-drawer', BundleDrawer);


